// Identificação legível de uma linha do orçamento nas mensagens de validação (item 13):
// "SERVIÇOS · linha 3 — Interpretes/Tradutores". Grupo + posição desambiguam linhas com o
// mesmo produto; a posição é a ordem da linha dentro do grupo na grade (1-based).
export function identificarLinhaOrcamento(grupo = {}, linhaIndex = 0, linha = {}, padraoProduto = 'Serviço') {
    const nomeGrupo = String(grupo?.produto?.nome || grupo?.nome || '').trim() || 'Grupo';
    const produto = String(linha?.produto?.nome || '').trim() || padraoProduto;
    return `${nomeGrupo} · linha ${linhaIndex + 1} — ${produto}`;
}
